import { Button, Container, Text, TextInput, PasswordInput } from '@mantine/core'
import React, { useEffect } from 'react';
import { login } from '../../actions/authActions';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from '@mantine/hooks';
import { useNotifications } from '@mantine/notifications';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";


const Login = ({ title }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const notifications = useNotifications();



    const form = useForm({
        initialValues: {
            email: '',
            password: '',
        },
        errorMessages: {
            email: 'Please re-check the entered email',
            password: 'Please re-check the entered password',
        },
        validationRules: {
            email: (value) => /^\S+@\S+$/.test(value),
        },
    });

    const { loading, error, userInfo } = useSelector((state) => state.userAccess);

    const handlerLogin = (values) => {
        const { email, password } = values;
        dispatch(login(email, password))
    }

    useEffect(() => {
        if (userInfo) {
            navigate('/')
        }
    }, [dispatch, userInfo, navigate])

    useEffect(() => {
        if (error) {
            notifications.showNotification({
                title: 'Error',
                message: error,
                color: 'red'
            })
        }
        // eslint-disable-next-line
    }, [error])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title}</title>
            </Helmet>
            <Container size='xs' sx={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

                <Text sx={{ fontSize: '30px', fontFamily: 'Poppins', fontWeight: 'bold' }}>Login to Carmax ERP</Text>
                <form onSubmit={form.onSubmit((values) => handlerLogin(values))}>
                    <TextInput
                        {...form.getInputProps('email')}
                        radius='md'
                        sx={{ marginTop: '20px', width: '100%', fontFamily: 'Poppins' }}
                        placeholder="Email"
                        label="Your email"
                        size='md'
                        required
                        error={form.errors.email}
                    />
                    <PasswordInput
                        {...form.getInputProps('password')}
                        radius='md'
                        sx={{ marginTop: '20px', width: '100%', fontFamily: 'Poppins' }}
                        placeholder="Password"
                        label="Your password"
                        size='md'
                        required
                        error={form.errors.password}
                    />
                    <Button loading={loading} type="submit" radius='md' size='md' sx={{ marginTop: '35px', width: '100%', fontFamily: 'Poppins' }} color="orange">Login</Button>
                </form>
            </Container>

        </>

    )
}

export default Login
